AppTabs.createTab( {
name: 'unit-conversion-factors',
icon: 'list-alt',
text: 'Unit Conversion Factors',
create: function(init) {
	'use strict'

	init.setDataTableArgs( {

		tableId: 		'#data-table-unit-conversion-factors',

		readTableName: 	'tblUnitConversionFactors',
		editTableName: 	'tblUnitConversionFactors',
		primaryKey: 	'UnitConversionFactorID',

		hasColumnFilters: 	true,
		canSearch: 			true,
		canSort:			true,
		paging:				false,

		actionData:			'datatable',
		actionAutofill: 	'datatable_autofill',
		actionCreate:		'datatable_create',
		actionEdit:			'datatable_edit',
		actionRemove:		'datatable_remove',

		fields: [
			{
				label: 		'Current Units',
				columnName: 'CurrentUnits',
				isEditable: true,
				order: 		'asc',
				type: 		'combobox',
				datalist: 	'units'
			},
			{
				label: 		'Convert To Units',
				columnName: 'ConvertToUnits',
				isEditable: true,
				type: 		'combobox',
				datalist: 	'units'
			},
			{
				label: 		'Conversion Factor',
				columnName: 'ConversionFactor',
				isEditable: true,
			},
		],

	} );
}

} );
